module.exports = RootreeVendor.React;